import { gql } from '@apollo/client';

export const GET_CATEGORY_LIST = gql`
  query Segments_findAll {
    Segments_findAll {
      id
      name
    }
  }
`;
